
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35274',
  depVersions: {
  "documents-public-ui": "static-1.35274",
  "atom": "static-1.5419",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2819",
  "client-types": "static-1.501",
  "cssUtils": "static-1.959",
  "customer-data-filters-ui": "static-1.41019",
  "customer-data-objects": "static-1.8034",
  "customer-data-property-utils": "static-1.8435",
  "documents-lib": "static-1.35279",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.373",
  "FormsCommonComponents": "static-1.86643",
  "FormUrlGenerator": "static-2.5063",
  "foundations-theming-specialty": "static-1.2529",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5927",
  "hs-test-utils": "static-1.8370",
  "hub-http": "static-1.6549",
  "hubspot-dlb": "static-2.1905",
  "HubStyle": "static-2.12136",
  "HubStyleTokens": "static-2.11829",
  "I18n": "static-7.1679",
  "icons": "static-2.693",
  "jasmine-immutable": "static-1.3357",
  "jasmine-runner": "static-1.6787",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7490",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3229",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5731",
  "quartz": "static-1.7504",
  "react": "static-7.196",
  "react-dlb": "static-1.89",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.79",
  "react-rhumb": "static-1-fkhalid-rhumb-remove-redundant-softnav.2",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5580",
  "react-virtualized": "static-2.107",
  "reference-resolvers": "static-1.8518",
  "reference-resolvers-lite": "static-1.8441",
  "reporting-data": "static-1.68919",
  "reporting-reports": "static-1.68595",
  "reporting-snowflake": "static-1.57535",
  "reporting-testing-lib": "static-1.10852",
  "reporting-visualizations": "static-1.60993",
  "reselect": "static-3.12",
  "sales-content-partitioning": "static-1.9289",
  "sanitize": "static-1.4809",
  "sanitize-text": "static-1.8494",
  "SharedI18nStrings": "static-1.183",
  "SharedLegalStrings": "static-1.2079",
  "signup-constants": "static-1.19683",
  "signup-ui-url-generator": "static-2.8397",
  "StyleGuideUI": "static-3.507",
  "superstore": "static-1.5096",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5093",
  "ui-addon-form-validation": "static-1.11321",
  "ui-asset-management-lib": "static-1.11437",
  "ui-images": "static-2.1262",
  "UIComponents": "static-3.8775",
  "usage-tracker": "static-1.7650",
  "usage-tracker-container": "static-1.7640",
  "usage-tracker-core": "static-1.7500",
  "viral-links-lib": "static-1.7413",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9990",
  "foundations-components": "static-1.8543",
  "immutable": "static-2.87",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1282",
  "quartz-core": "static-1.6723",
  "quick-fetch": "static-1.4152",
  "raven": "static-3.5925",
  "redux": "static-4.80",
  "redux-thunk": "static-2.80",
  "rpc-client-utils": "static-1.5003",
  "ui-addon-i18n": "static-1.11483",
  "ui-addon-upgrades": "static-9.18427",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4366",
  "metrics-js": "static-1.9963",
  "styled-components": "static-2.99",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3781",
  "quartz-webpack": "static-1.3728",
  "foundations-assets": "static-1.5224",
  "foundations-theming": "static-1.4813",
  "hub-http-janus": "static-1.887",
  "hub-http-shared-msw-handlers": "static-1.10676",
  "hubspotter-http": "static-1.4888",
  "sassPrefix": "static-1.226",
  "conversations-skeleton-state": "static-1.7584",
  "crm-message-bus": "static-1.43836",
  "customer-data-filters-ui-msw-helpers": "static-1.23454",
  "customer-data-objects-ui-components": "static-1.13368",
  "customer-data-reference-ui-components": "static-1.13516",
  "customer-data-ui-utilities": "static-1.10168",
  "events-data-lib": "static-1.586",
  "framework-builder-read-service-client": "static-1.4246",
  "hs-resources": "static-1.530",
  "immer": "static-1.101",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4072",
  "multi-account-reference-resolvers": "static-1.1345",
  "onboarding-scopes": "static-1.6790",
  "onboarding-tours": "static-1.17181",
  "pulse": "static-1.967",
  "reporting-datasets-permissions-lib": "static-1.14527",
  "stylex": "static-1.41",
  "trellis-assets": "static-1.2733",
  "trellis-components": "static-1.2752",
  "trellis-theming": "static-1.1310",
  "ui-addon-teams": "static-1.21948",
  "quartz-auth": "static-1.1179",
  "ui-business-units-lib": "static-1.9428",
  "usage-tracker-session-replay": "static-1.5336",
  "ai-components-ui-library": "static-1.9789",
  "ContentUtils": "static-1.69195",
  "customer-data-properties": "static-1.52689",
  "forms-ai-lib": "static-1.4806",
  "forms-utils-lib": "static-1.13137",
  "foundations-components-test-utils": "static-1.6026",
  "react-dnd-compat": "static-1.4953",
  "react-tinymce": "static-1.56041",
  "tinymce-config": "static-2.55167",
  "ui-gdpr-components": "static-1.10633",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3798",
  "HeadJS": "static-2.803",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3481",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "hs-locale-management": "static-1.319",
  "ui-fonts": "static-1.1091",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4649",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1169",
  "web-vitals": "static-1.15",
  "batch-promise": "static-1.1882",
  "external-options-client-types": "static-1.4365",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7230",
  "quartz-i18n": "static-1.1179",
  "frontend-preferences-client": "static-1.8256",
  "graphql": "static-1.89",
  "persist-promise": "static-1.4039",
  "reporting-client-types": "static-1.2715",
  "apollo-stack-hubspot": "static-3.94",
  "growth-payments-core": "static-1.26252",
  "hubspot-apollo-client": "static-1.5214",
  "foundations-components-legacy": "static-1.1568",
  "quartz-routing": "static-1.934",
  "hs-story-utils": "static-1.9762",
  "react-flip-move": "static-1.78",
  "nested-table": "static-1.572",
  "seat-types-lib": "static-1.799",
  "timezone-utils": "static-2.5580",
  "react-create-root-preference": "static-1.78",
  "bend-plugin-foundations-components": "static-1.4812",
  "floating-ui": "static-1.63",
  "react-aria": "static-1.72",
  "tanstack-table": "static-1.61",
  "opentelemetry-fe-types": "static-1.113",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.583",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.488",
  "quartz-test": "static-1.1179",
  "quartz-tracking": "static-1.883",
  "bend-plugin-chirp-manifest": "static-1.413",
  "chirp-fetch": "static-1.2233",
  "merchandise-lib": "static-1.279",
  "purchase-motions-components": "static-1.6422",
  "ts-schema": "static-1.4318",
  "bender-build-tools": "static-1.3452",
  "bend-plugin-foundations-theming": "static-1.3296",
  "restore-request-side-panel-lib": "static-1.1739",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4994",
  "conditional-properties-service-client": "static-1.4041",
  "crm-pipelines-api-client-types": "static-1.4372",
  "event-emitter": "static-1.1292",
  "fdsr-migration-layer": "static-1.349",
  "multi-currency-client-types": "static-1.3932",
  "getting-started-shared-tasks": "static-1.19310",
  "growth-data-modal": "static-1.5940",
  "growth-onboarding-confetti": "static-1.3402",
  "growth-onboarding-next-action-utils": "static-1.2752",
  "navigation-components": "static-1.18899",
  "onboarding-tours-client": "static-1.5396",
  "onboarding-tours-utils": "static-1.1248",
  "ui-shepherd-react": "static-3.10607",
  "ui-shepherd-tracker": "static-1.7988",
  "ui-universal-auth": "static-1.9465",
  "user-context": "static-1.5458",
  "bend-plugin-pulse": "static-1.470",
  "fast-json-patch": "static-1.70",
  "stylex-utils": "static-1.147",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "hubspotter-http-shared-msw-handlers": "static-1.10674",
  "magpie-lib": "static-1.5782",
  "navigation-messaging": "static-1.8226",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23183",
  "copilot-toolkit": "static-1.11905",
  "cms-field-types": "static-1.5149",
  "content-icons-ui": "static-1.2400",
  "integrations-lib": "static-1.17136",
  "calling-global-api": "static-1.65734",
  "calling-internal-common": "static-1.31659",
  "calling-lifecycle-internal": "static-1.67116",
  "calling-lifecycle-messages": "static-1.59410",
  "commerce-products-lib": "static-1.10611",
  "crm-index-visualization-core": "static-1.4585",
  "crm-links": "static-1.6658",
  "customer-data-properties-shared-msw-handlers": "static-1.10003",
  "file-manager-components": "static-1.24582",
  "formula-editor": "static-1.14816",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4453",
  "meetings-icalendar-utils-lib": "static-1.972",
  "object-builder-ui-client": "static-1.49756",
  "pipeline-validation-client-types": "static-1.4207",
  "property-value-citations": "static-1.3303",
  "smart-data-capture-core": "static-1.198",
  "smart-property-lib": "static-1.8369",
  "tiered-pricing": "static-1.2011",
  "topics-actions-lib": "static-1.507",
  "trial-components-library": "static-1.14164",
  "ui-addon-iframeable": "static-1.9414",
  "zustand": "static-1.85",
  "final-form": "static-1.78",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.78",
  "rich-text-lib": "static-1.20352",
  "tinymce-themes": "static-1.57137",
  "data-token-picker": "static-1.16932",
  "hub-http-contrib": "static-1.3377",
  "interframe": "static-3.5092",
  "tinymce-data": "static-1.41252",
  "tinymce-plugins": "static-1.58281",
  "ui-addon-sales-email": "static-1.5551",
  "framework-data-schema-quick-fetch": "static-1.7135",
  "ui-addon-opt": "static-4.8703",
  "hubspot-apollo-cache": "static-1.673",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.485",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.41",
  "purchase-motions-api": "static-1.6425",
  "onboarding-data-sync-lib": "static-1.2562",
  "growth-onboarding-next-action-components": "static-1.2780",
  "user-context-client": "static-1.4845",
  "idb-keyval": "static-1.51",
  "magpie-types": "static-1.5242",
  "nest": "static-1.574",
  "reactive-lib": "static-1.1056",
  "simple-logging-lib": "static-1.3388",
  "unified-auth-core-lib": "static-1.1261",
  "getting-started-shared-tasks-store": "static-1.18428",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1827",
  "integrations-error-boundary-lib": "static-1.14551",
  "integrations-tracking-lib": "static-1.5945",
  "native-integrations-shared-strings": "static-1.8114",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10707",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.979",
  "calling-error-reporting": "static-1.31666",
  "shared-worker-versioning": "static-1.11378",
  "calling-usage-tracker": "static-1.6873",
  "voice-sms-access-library": "static-1.2131",
  "customer-data-tracking": "static-1.7219",
  "commerce-permissions": "static-1.1114",
  "products-iframe-lib": "static-1.8646",
  "products-ui-components-shared-msw-handlers": "static-1.11058",
  "crm-index-associations-lib": "static-1.6781",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10759",
  "sales-views-client-types": "static-1.4593",
  "location-customization-utils-lib": "static-1.10165",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4483",
  "video-components-external": "static-1.12208",
  "video-data-lib": "static-1.35866",
  "bark-lib": "static-1.16852",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.102",
  "crm-properties-common-lib": "static-1.6227",
  "react-codemirror": "static-1.10980",
  "data-agent-kit": "static-1.698",
  "feedback-loader": "static-1.29856",
  "fsm": "static-1.4090",
  "policy-lib": "static-1.7142",
  "react-colorpicker": "static-2.10550",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10822",
  "embedded-academy-lib": "static-1.15627",
  "hubs-service-types": "static-1.1597",
  "salesImages": "static-1.597",
  "FileManagerLib": "static-1.40222",
  "NamespacedHubStyle": "static-2.9290",
  "FileManagerCore": "static-1.40081",
  "content-assistance-lib": "static-1.8243",
  "layout-dnd-components": "static-1.13018",
  "layout-dnd-utils": "static-1.11993",
  "ui-addon-emoji-picker": "static-1.10221",
  "ui-brand-identity-lib": "static-1.16618",
  "InboxConnectUtils": "static-4.15618",
  "meetings-connect-utils-lib": "static-1.7948",
  "breeze-engine-chat-components": "static-1.805",
  "breeze-engine-core": "static-1.1105",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "universal-page-editor-lib": "static-1.3345",
  "adobe-sign-auth-lib": "static-1.530",
  "ads-unified-auth-lib": "static-1.1501",
  "custom-vendor-connection-lib": "static-1.29",
  "google-sheets-integration-lib": "static-1.1093",
  "microsoft-drive-auth-lib": "static-1.209",
  "surveymonkey-integration-lib": "static-1.548",
  "slack-ui-library": "static-1.10736",
  "calling-orchestration-schema": "static-1.36908",
  "crm-record-cards-service-types": "static-1.3796",
  "content-media-composition-data-lib": "static-1.13320",
  "content-media-compositions": "static-2.17327",
  "media-bridge-lib": "static-1.19450",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16426",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4844",
  "storybook-react": "static-1.40",
  "academy-common-lib": "static-1.15087",
  "audio-components": "static-1.6390",
  "FileManagerImages": "static-1.37733",
  "video-components": "static-1.14210",
  "breeze-artifacts-sdk": "static-1.453",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4867",
  "video-embed": "static-1.36700",
  "ui-addon-video-player": "static-1.9039",
  "ui-coaching-tips": "static-1.29371",
  "ContentData": "static-1.69270",
  "layout-data-lib": "static-1.10318",
  "academy-service-client": "static-1.4029",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4743",
  "trellis-ecosystem": "static-1.7671",
  "ui-addon-react-router-dom": "static-1.9869",
  "wootric-nps": "static-1.7225",
  "social-insights-client-types": "static-1.22706",
  "outpost": "static-1.4490",
  "growth-onboarding-feedback-components": "static-1.6922",
  "advanced-menus-core": "static-1.15622",
  "advanced-menus-lib": "static-1.12494",
  "ExportDialog": "static-6.10715",
  "ui-memberships-settings-lib": "static-1.34905",
  "marketplace-ui-apps-core": "static-1.19331",
  "marketplace-ui-common": "static-1.20799",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15621",
  "simple-menus-lib": "static-1.17138",
  "settings-ui-lib": "static-1.12861",
  "developer-experience-shared-components": "static-1.10875",
  "immutable-less": "static-1.4988",
  "marketplace-ui-client-types": "static-1.18206",
  "ui-addon-integrations-directory-panel": "static-2.8364",
  "ui-extensibility-client-types": "static-1.4254",
  "ai-settings-ui-library": "static-1.8388",
  "nav-meta": "static-1.30536",
  "ui-product-approvals-common": "static-1.1164",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4570",
  "simple-data-table": "static-1.3577"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35274",
  "atom": "/atom/static-1.5419",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2819",
  "client-types": "/client-types/static-1.501",
  "cssUtils": "/cssUtils/static-1.959",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41019",
  "customer-data-objects": "/customer-data-objects/static-1.8034",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8435",
  "documents-lib": "/documents-lib/static-1.35279",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.373",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86643",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5063",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2529",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5927",
  "hs-test-utils": "/hs-test-utils/static-1.8370",
  "hub-http": "/hub-http/static-1.6549",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "HubStyle": "/HubStyle/static-2.12136",
  "HubStyleTokens": "/HubStyleTokens/static-2.11829",
  "I18n": "/I18n/static-7.1679",
  "icons": "/icons/static-2.693",
  "jasmine-immutable": "/jasmine-immutable/static-1.3357",
  "jasmine-runner": "/jasmine-runner/static-1.6787",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7490",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3229",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5731",
  "quartz": "/quartz/static-1.7504",
  "react": "/react/static-7.196",
  "react-dlb": "/react-dlb/static-1.89",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.79",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-rhumb-remove-redundant-softnav.2",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5580",
  "react-virtualized": "/react-virtualized/static-2.107",
  "reference-resolvers": "/reference-resolvers/static-1.8518",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8441",
  "reporting-data": "/reporting-data/static-1.68919",
  "reporting-reports": "/reporting-reports/static-1.68595",
  "reporting-snowflake": "/reporting-snowflake/static-1.57535",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10852",
  "reporting-visualizations": "/reporting-visualizations/static-1.60993",
  "reselect": "/reselect/static-3.12",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9289",
  "sanitize": "/sanitize/static-1.4809",
  "sanitize-text": "/sanitize-text/static-1.8494",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2079",
  "signup-constants": "/signup-constants/static-1.19683",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8397",
  "StyleGuideUI": "/StyleGuideUI/static-3.507",
  "superstore": "/superstore/static-1.5096",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5093",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11321",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11437",
  "ui-images": "/ui-images/static-2.1262",
  "UIComponents": "/UIComponents/static-3.8775",
  "usage-tracker": "/usage-tracker/static-1.7650",
  "usage-tracker-container": "/usage-tracker-container/static-1.7640",
  "usage-tracker-core": "/usage-tracker-core/static-1.7500",
  "viral-links-lib": "/viral-links-lib/static-1.7413",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9990",
  "foundations-components": "/foundations-components/static-1.8543",
  "immutable": "/immutable/static-2.87",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1282",
  "quartz-core": "/quartz-core/static-1.6723",
  "quick-fetch": "/quick-fetch/static-1.4152",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.80",
  "redux-thunk": "/redux-thunk/static-2.80",
  "rpc-client-utils": "/rpc-client-utils/static-1.5003",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11483",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18427",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "metrics-js": "/metrics-js/static-1.9963",
  "styled-components": "/styled-components/static-2.99",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3781",
  "quartz-webpack": "/quartz-webpack/static-1.3728",
  "foundations-assets": "/foundations-assets/static-1.5224",
  "foundations-theming": "/foundations-theming/static-1.4813",
  "hub-http-janus": "/hub-http-janus/static-1.887",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10676",
  "hubspotter-http": "/hubspotter-http/static-1.4888",
  "sassPrefix": "/sassPrefix/static-1.226",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7584",
  "crm-message-bus": "/crm-message-bus/static-1.43836",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23454",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13368",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13516",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10168",
  "events-data-lib": "/events-data-lib/static-1.586",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4246",
  "hs-resources": "/hs-resources/static-1.530",
  "immer": "/immer/static-1.101",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4072",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1345",
  "onboarding-scopes": "/onboarding-scopes/static-1.6790",
  "onboarding-tours": "/onboarding-tours/static-1.17181",
  "pulse": "/pulse/static-1.967",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14527",
  "stylex": "/stylex/static-1.41",
  "trellis-assets": "/trellis-assets/static-1.2733",
  "trellis-components": "/trellis-components/static-1.2752",
  "trellis-theming": "/trellis-theming/static-1.1310",
  "ui-addon-teams": "/ui-addon-teams/static-1.21948",
  "quartz-auth": "/quartz-auth/static-1.1179",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9428",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5336",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9789",
  "ContentUtils": "/ContentUtils/static-1.69195",
  "customer-data-properties": "/customer-data-properties/static-1.52689",
  "forms-ai-lib": "/forms-ai-lib/static-1.4806",
  "forms-utils-lib": "/forms-utils-lib/static-1.13137",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6026",
  "react-dnd-compat": "/react-dnd-compat/static-1.4953",
  "react-tinymce": "/react-tinymce/static-1.56041",
  "tinymce-config": "/tinymce-config/static-2.55167",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10633",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3798",
  "HeadJS": "/HeadJS/static-2.803",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3481",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "hs-locale-management": "/hs-locale-management/static-1.319",
  "ui-fonts": "/ui-fonts/static-1.1091",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4649",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1169",
  "web-vitals": "/web-vitals/static-1.15",
  "batch-promise": "/batch-promise/static-1.1882",
  "external-options-client-types": "/external-options-client-types/static-1.4365",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7230",
  "quartz-i18n": "/quartz-i18n/static-1.1179",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8256",
  "graphql": "/graphql/static-1.89",
  "persist-promise": "/persist-promise/static-1.4039",
  "reporting-client-types": "/reporting-client-types/static-1.2715",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "growth-payments-core": "/growth-payments-core/static-1.26252",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5214",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1568",
  "quartz-routing": "/quartz-routing/static-1.934",
  "hs-story-utils": "/hs-story-utils/static-1.9762",
  "react-flip-move": "/react-flip-move/static-1.78",
  "nested-table": "/nested-table/static-1.572",
  "seat-types-lib": "/seat-types-lib/static-1.799",
  "timezone-utils": "/timezone-utils/static-2.5580",
  "react-create-root-preference": "/react-create-root-preference/static-1.78",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4812",
  "floating-ui": "/floating-ui/static-1.63",
  "react-aria": "/react-aria/static-1.72",
  "tanstack-table": "/tanstack-table/static-1.61",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.113",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.583",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.488",
  "quartz-test": "/quartz-test/static-1.1179",
  "quartz-tracking": "/quartz-tracking/static-1.883",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.413",
  "chirp-fetch": "/chirp-fetch/static-1.2233",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "purchase-motions-components": "/purchase-motions-components/static-1.6422",
  "ts-schema": "/ts-schema/static-1.4318",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3296",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1739",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4994",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4041",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4372",
  "event-emitter": "/event-emitter/static-1.1292",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.349",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3932",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19310",
  "growth-data-modal": "/growth-data-modal/static-1.5940",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3402",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2752",
  "navigation-components": "/navigation-components/static-1.18899",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5396",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1248",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10607",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7988",
  "ui-universal-auth": "/ui-universal-auth/static-1.9465",
  "user-context": "/user-context/static-1.5458",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.470",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "stylex-utils": "/stylex-utils/static-1.147",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10674",
  "magpie-lib": "/magpie-lib/static-1.5782",
  "navigation-messaging": "/navigation-messaging/static-1.8226",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23183",
  "copilot-toolkit": "/copilot-toolkit/static-1.11905",
  "cms-field-types": "/cms-field-types/static-1.5149",
  "content-icons-ui": "/content-icons-ui/static-1.2400",
  "integrations-lib": "/integrations-lib/static-1.17136",
  "calling-global-api": "/calling-global-api/static-1.65734",
  "calling-internal-common": "/calling-internal-common/static-1.31659",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67116",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59410",
  "commerce-products-lib": "/commerce-products-lib/static-1.10611",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4585",
  "crm-links": "/crm-links/static-1.6658",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10003",
  "file-manager-components": "/file-manager-components/static-1.24582",
  "formula-editor": "/formula-editor/static-1.14816",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4453",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.972",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49756",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4207",
  "property-value-citations": "/property-value-citations/static-1.3303",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.198",
  "smart-property-lib": "/smart-property-lib/static-1.8369",
  "tiered-pricing": "/tiered-pricing/static-1.2011",
  "topics-actions-lib": "/topics-actions-lib/static-1.507",
  "trial-components-library": "/trial-components-library/static-1.14164",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9414",
  "zustand": "/zustand/static-1.85",
  "final-form": "/final-form/static-1.78",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "rich-text-lib": "/rich-text-lib/static-1.20352",
  "tinymce-themes": "/tinymce-themes/static-1.57137",
  "data-token-picker": "/data-token-picker/static-1.16932",
  "hub-http-contrib": "/hub-http-contrib/static-1.3377",
  "interframe": "/interframe/static-3.5092",
  "tinymce-data": "/tinymce-data/static-1.41252",
  "tinymce-plugins": "/tinymce-plugins/static-1.58281",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5551",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7135",
  "ui-addon-opt": "/ui-addon-opt/static-4.8703",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.673",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.485",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.41",
  "purchase-motions-api": "/purchase-motions-api/static-1.6425",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2562",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2780",
  "user-context-client": "/user-context-client/static-1.4845",
  "idb-keyval": "/idb-keyval/static-1.51",
  "magpie-types": "/magpie-types/static-1.5242",
  "nest": "/nest/static-1.574",
  "reactive-lib": "/reactive-lib/static-1.1056",
  "simple-logging-lib": "/simple-logging-lib/static-1.3388",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1261",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18428",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1827",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14551",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5945",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8114",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10707",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.979",
  "calling-error-reporting": "/calling-error-reporting/static-1.31666",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11378",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6873",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2131",
  "customer-data-tracking": "/customer-data-tracking/static-1.7219",
  "commerce-permissions": "/commerce-permissions/static-1.1114",
  "products-iframe-lib": "/products-iframe-lib/static-1.8646",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11058",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6781",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10759",
  "sales-views-client-types": "/sales-views-client-types/static-1.4593",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10165",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4483",
  "video-components-external": "/video-components-external/static-1.12208",
  "video-data-lib": "/video-data-lib/static-1.35866",
  "bark-lib": "/bark-lib/static-1.16852",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.102",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6227",
  "react-codemirror": "/react-codemirror/static-1.10980",
  "data-agent-kit": "/data-agent-kit/static-1.698",
  "feedback-loader": "/feedback-loader/static-1.29856",
  "fsm": "/fsm/static-1.4090",
  "policy-lib": "/policy-lib/static-1.7142",
  "react-colorpicker": "/react-colorpicker/static-2.10550",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10822",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15627",
  "hubs-service-types": "/hubs-service-types/static-1.1597",
  "salesImages": "/salesImages/static-1.597",
  "FileManagerLib": "/FileManagerLib/static-1.40222",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9290",
  "FileManagerCore": "/FileManagerCore/static-1.40081",
  "content-assistance-lib": "/content-assistance-lib/static-1.8243",
  "layout-dnd-components": "/layout-dnd-components/static-1.13018",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11993",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10221",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16618",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15618",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7948",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.805",
  "breeze-engine-core": "/breeze-engine-core/static-1.1105",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3345",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.530",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1501",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.29",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1093",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.209",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.548",
  "slack-ui-library": "/slack-ui-library/static-1.10736",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36908",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13320",
  "content-media-compositions": "/content-media-compositions/static-2.17327",
  "media-bridge-lib": "/media-bridge-lib/static-1.19450",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16426",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4844",
  "storybook-react": "/storybook-react/static-1.40",
  "academy-common-lib": "/academy-common-lib/static-1.15087",
  "audio-components": "/audio-components/static-1.6390",
  "FileManagerImages": "/FileManagerImages/static-1.37733",
  "video-components": "/video-components/static-1.14210",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.453",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4867",
  "video-embed": "/video-embed/static-1.36700",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9039",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29371",
  "ContentData": "/ContentData/static-1.69270",
  "layout-data-lib": "/layout-data-lib/static-1.10318",
  "academy-service-client": "/academy-service-client/static-1.4029",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4743",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7671",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9869",
  "wootric-nps": "/wootric-nps/static-1.7225",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "outpost": "/outpost/static-1.4490",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6922",
  "advanced-menus-core": "/advanced-menus-core/static-1.15622",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12494",
  "ExportDialog": "/ExportDialog/static-6.10715",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34905",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19331",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20799",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15621",
  "simple-menus-lib": "/simple-menus-lib/static-1.17138",
  "settings-ui-lib": "/settings-ui-lib/static-1.12861",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10875",
  "immutable-less": "/immutable-less/static-1.4988",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18206",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8364",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4254",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8388",
  "nav-meta": "/nav-meta/static-1.30536",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1164",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4570",
  "simple-data-table": "/simple-data-table/static-1.3577"
}
};
